export const DateView = (props: { date: Date }) => {
    return (
        <div className="flex flex-row gap-1 items-center">
            <p>{props.date.toLocaleDateString('fr')}</p>
        </div>
    );
};
